"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable:max-line-length */
var React = require("react");
var classNames = require("classnames");
var SvgIcon_1 = require("../components/SvgIcon");
var Provider_1 = require("../components/Provider");
function iconFactory(opts) {
    var Icon = function (props) {
        var _a = props, className = _a.className, spinning = _a.spinning, other = __rest(_a, ["className", "spinning"]);
        var componentClassName = classNames('ee_icon', {
            'ee_icon--spinning': spinning
        }, className);
        return (React.createElement(Provider_1.ErgoElementsContext.Consumer, null, function (context) {
            // console.log(context, props);
            var theme = context.theme;
            var idGenerator = context.idGenerator;
            var themedOpts = opts.gThemed && opts.gThemed[theme];
            // Theme DAS and DKV should fall back to theme ERGO
            if (!themedOpts) {
                if (theme === 'das' || theme === 'dkv') {
                    themedOpts = opts.gThemed && opts.gThemed.ergo;
                }
                else if (theme === 'ergo-one') {
                    themedOpts = opts.gThemed && opts.gThemed.ergodirekt;
                }
            }
            // If there is no themed icon, use the default one
            var _a = themedOpts || opts, g = _a.g, viewBox = _a.viewBox;
            return (React.createElement(SvgIcon_1.default, __assign({}, other, { idGenerator: idGenerator, className: componentClassName, viewBox: viewBox, g: g })));
        }));
    };
    Icon.defaultProps = SvgIcon_1.iconDefaultProps;
    Icon.propTypes = SvgIcon_1.iconPropTypes;
    Icon.displayName = opts.componentName;
    return Icon;
}
exports.iconFactory = iconFactory;
//# sourceMappingURL=iconFactory.js.map
